import { useQueryClient } from '@tanstack/react-query'
import { QueryKeys } from '../../../key-registry'
import { fetchTransitOperation } from '../api/fetchTransitOperation'
import { submitEnsPresentationNotification } from '../api/http'

function useEnsPresentationNotification(transitOperationId: number | null) {
  const qc = useQueryClient()

  const sendEnsPresentationNotification = async () => {
    if (!transitOperationId) throw new Error('Missing transit operation id')
    await submitEnsPresentationNotification({ id: transitOperationId })

    const updated = await fetchTransitOperation(transitOperationId, true)
    qc.setQueriesData(
      {
        queryKey: QueryKeys.transitOperation.detailById({ id: updated.id as number }),
      },
      (prev) => {
        if (!prev) return prev
        return { ...prev, ...updated }
      },
    )
    await qc.invalidateQueries({
      queryKey: QueryKeys.eventLog.all(transitOperationId),
    })

    return updated
  }

  return {
    sendEnsPresentationNotification,
  }
}

export default useEnsPresentationNotification
